export default {"src":"/_next/static/media/circle.62c358cd.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};